var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { staticClass: "align-stretch justify-start" },
        [
          _vm.currentUser.team && _vm.currentUser.team.teamId
            ? _c(
                "v-col",
                { staticClass: "pa-2 pt-0", attrs: { cols: "12", md: "4" } },
                [
                  _c("TeamWidget", {
                    attrs: { teamId: _vm.currentUser.team.teamId },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userHasRole("ROLE_EVENTING_DATA") &&
          _vm.currentUser.team &&
          _vm.currentUser.team.teamId
            ? _c(
                "v-col",
                { staticClass: "pa-2 pt-0", attrs: { cols: "12", md: "4" } },
                [
                  _c("LastGameWidget", {
                    attrs: { teamId: _vm.currentUser.team.teamId },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentUser.team && _vm.currentUser.team.teamId
            ? _c(
                "v-col",
                { staticClass: "pa-2 pt-0", attrs: { cols: "12", md: "4" } },
                [
                  _c("NextGameWidget", {
                    attrs: { teamId: _vm.currentUser.team.teamId },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userHasRole("ROLE_DRIBLAB_HUB")
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12", md: "8" } },
                [_c("LastScoutingAnalysesWidget")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userHasRole("ROLE_DRIBLAB_HUB")
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12", md: "4" } },
                [_c("ScoutingTasksWidget")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userHasRole("ROLE_VIDEO")
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12", md: "8" } },
                [_c("UploadedGamesWidget")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userHasRole("ROLE_VIDEO")
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12", md: "4" } },
                [_c("CapturePlaylistsWidget")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentUser.team && _vm.currentUser.team.seasonId
            ? _c(
                "v-col",
                {
                  staticClass: "pa-2",
                  attrs: { cols: "12", md: "8" },
                  on: {
                    mouseenter: function ($event) {
                      return _vm.cycling(false)
                    },
                    mouseleave: function ($event) {
                      return _vm.cycling(true)
                    },
                  },
                },
                [
                  _c(
                    "v-carousel",
                    {
                      staticClass: "elevation-2",
                      attrs: {
                        cycle: _vm.cycle,
                        "hide-delimiters": "",
                        height: "auto",
                        "show-arrows-on-hover": "",
                        light: !_vm.$vuetify.theme.dark,
                      },
                    },
                    [
                      _c(
                        "v-carousel-item",
                        [
                          _c("LastMatchdayGamesWidget", {
                            attrs: { seasonId: _vm.currentUser.team.seasonId },
                            on: {
                              heightChange: function ($event) {
                                _vm.lastMatchdayGameHeight = $event
                                  ? $event
                                  : _vm.lastMatchdayGameHeight
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-carousel-item",
                        [
                          _c("NextMatchdayGamesWidget", {
                            attrs: { seasonId: _vm.currentUser.team.seasonId },
                            on: {
                              heightChange: function ($event) {
                                _vm.lastMatchdayGameHeight = $event
                                  ? $event
                                  : _vm.lastMatchdayGameHeight
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "pa-2", attrs: { cols: "12", md: "4" } },
            [
              _c("LastPlayersSearch", {
                style: { height: _vm.lastMatchdayGameHeight + "px" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.userHasRole("ROLE_EVENTING_DATA")
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12", md: "8" } },
                [
                  _c("ChartsWidget", {
                    staticClass: "elevation-2",
                    attrs: {
                      slides: [
                        "npgVsXGChart",
                        "xGAgainstvsNPGAgainstChart",
                        "pointsVsXPointsChart",
                      ],
                    },
                    on: {
                      heightChange: function ($event) {
                        _vm.charts1Height = $event
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "pa-2", attrs: { cols: "12", md: "4" } },
            [
              _c("FavoritesWidget", {
                style: { height: _vm.charts1Height + "px" },
                attrs: { userId: _vm.currentUser.id },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.userHasRole("ROLE_EVENTING_DATA")
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12", md: "8" } },
                [
                  _c("ChartsWidget", {
                    staticClass: "elevation-2",
                    attrs: { slides: ["xGvsxGAgainstChart"] },
                    on: {
                      heightChange: function ($event) {
                        _vm.charts2Height = $event
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "pa-2", attrs: { cols: "12", md: "4" } },
            [
              _c("CollectionsWidget", {
                style: { height: _vm.charts2Height + "px" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }